import { createStandardAction } from 'typesafe-actions';

import { IDialog } from '../../../types/ui';

const SET_DIALOG = 'ui/SET_DIALOG';
const SET_DIALOG_OPEN = 'ui/SET_DIALOG_OPEN';

export interface ISetDialogOpenPayload {
  open: boolean;
}

export const setDialogOpen = createStandardAction(SET_DIALOG_OPEN)<
  ISetDialogOpenPayload
>();

export interface ISetDialogPayload {
  dialog: IDialog | null;
}

export const setDialog = createStandardAction(SET_DIALOG)<ISetDialogPayload>();
